module.exports = __webpack_public_path__ + "img/Youthassociation.faabbb11.jpg";